document.addEventListener("DOMContentLoaded", function () {
  const $testimonialSlider = $('.block_testimonials-slider');

  // Run when slick is fully initialized
  $testimonialSlider.on('init', function (event, slickInstance) {
    equl(".block_testimonials-slider-desc p");
  });

  $testimonialSlider.slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $('.block_testimonials-left-arrows'),
    nextArrow: $('.block_testimonials-right-arrows'),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});

		